import * as yup from "yup";
import { useState } from "react";
import { toast } from "react-toastify";
import { Trans, useTranslation } from "react-i18next";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, SubmitHandler } from "react-hook-form";

import Loaing from "../../icons/loaing";
import ConfirmModal from "../ConfirmModal";
import Input from "../event-selection/Input";
import TextArea from "../event-selection/textArea";
import Checkboxes from "../event-selection/checkboxes";
import SelectAndQmark from "../event-selection/select&Qmark";
import SelectElement from "../event-selection/selectElement";
import { closeReporting } from "../../services/dashboardService";
import CustomCheckboxes from "../event-selection/customCheckboxes";
import { updateHealthEventsServie } from "../../services/healthEventsService";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { HealthEventPDF } from "./healthevent-pdf";
import moment from "moment";
import DeletePopup from "./delete-popup";
import { UPDATE_VALUES } from "../../data/constants";
import FormDateInput from "../FormDateInput";
import AdminWrapper from "../misc/AdminWrapper";

export type updateHealthInputsTypes = {
  __v: number;
  _id: string;
  reporting: string;
  reportingId: string;
  eventDate: string;
  eventTime: Date;
  eventMoment: string;
  eventType: string[];
  eventLocation: string;
  eventDescription: string;
  emsContacted: string;
  hospitalization: string[];
  localAuthorityBeNotified: string;
  localAuthorityBeenNotified: string;
  parentsBeenInformed: string;
  securityLevel: string;
  aftercare: string;
  childAbsence: string;
  supervisionRateRespected: string;
  usualTeam: string;
  professionalNames: string;
  riskRelatedEvent: string;
  riskRelatedEventArray?: string[];
  ageOfChild: string;
  insuranceBeNotified: string;
  insuranceBeenNotified: string;
  status?: string;
  eventId?: number;
  perimeter?: string;
  institutionId?: string;
  printeventDate: boolean;
  printeventTime: Date;
  printeventMoment: boolean;
  printeventType: boolean;
  printeventLocation: boolean;
  printeventDescription: boolean;
  printemsContacted: boolean;
  printhospitalization: boolean;
  printlocalAuthorityBeNotified: boolean;
  printlocalAuthorityBeenNotified: boolean;
  printparentsBeenInformed: boolean;
  printsecurityLevel: boolean;
  printaftercare: boolean;
  printchildAbsence: boolean;
  printsupervisionRateRespected: boolean;
  printusualTeam: boolean;
  printprofessionalNames: boolean;
  printriskRelatedEventArray: boolean;
  printriskRelatedEvent: boolean;
  printageOfChild: boolean;
  printinsuranceBeNotified: boolean;
  printinsuranceBeenNotified: boolean;
  setOpen: (value: boolean) => void;
  updateRecord: (value: any) => void;
  selectedPeriod: string;
};

const schema = yup.object({
  eventDate: yup.string().required(),
  eventTime: yup.string().required(),
  eventMoment: yup.string().required(),
  eventType: yup.string().required(),
  hospitalization: yup.string().required(),
  eventLocation: yup.string().required(),
  eventDescription: yup.string().required(),
  emsContacted: yup.string().required(),
  localAuthorityBeNotified: yup.string().required(),
  localAuthorityBeenNotified: yup.string().required(),
  parentsBeenInformed: yup.string().required(),
  securityLevel: yup.string().required(),
  aftercare: yup.string().required(),
  childAbsence: yup.string().required(),
  supervisionRateRespected: yup.string().required(),
  usualTeam: yup.string().required(),
  professionalNames: yup.string().required(),
  riskRelatedEventArray: yup
    .array()
    .min(1, "riskRelatedEvent is a required field!")
    .test(
      "no-empty-strings",
      "Array cannot contain empty string values",
      (value) => {
        return new Promise((resolve) => {
          resolve(value?.every((item) => item !== "") ?? false);
        });
      }
    ),
  ageOfChild: yup.string().required(),
  insuranceBeNotified: yup.string().required(),
  insuranceBeenNotified: yup.string().required(),
});

const UpdateHealthEvents: React.FC<updateHealthInputsTypes> = ({
  reporting,
  reportingId,
  setOpen,
  updateRecord,
  selectedPeriod,
  ...props
}) => {
  const [loading, setLoading] = useState(false);
  const [confirmModalVisible, setConfirmModalVisible] = useState(false);
  const [editEnabled, setEditEnabled] = useState(false);
  const [pdfData, setPdfData] = useState<any>(null);
  const [openDeletePopup, setOpenDeletePopup] = useState(false);
  const [date, setDate] = useState<string>(
    props.eventDate === "Invalid date"
      ? moment(selectedPeriod).format("YYYY-MM-DD")
      : props.eventDate
  );

  const {
    control,
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<updateHealthInputsTypes>({
    resolver: yupResolver(schema),
    defaultValues: { ...props },
  });

  const { t } = useTranslation();

  const handleDownload: SubmitHandler<updateHealthInputsTypes> = async (
    data
  ) => {
    data.riskRelatedEvent =
      data.riskRelatedEventArray?.map((value) => value).join("-,-") ?? "";
    data.eventDate = moment(data.eventDate).format("YYYY-MM-DD");
    data.printriskRelatedEvent = data.printriskRelatedEventArray;
    setPdfData(data);
  };

  const onSubmit: SubmitHandler<updateHealthInputsTypes> = async (data) => {
    setLoading(true);
    try {
      const {
        printeventDate,
        printeventTime,
        printeventMoment,
        printeventType,
        printeventLocation,
        printeventDescription,
        printemsContacted,
        printhospitalization,
        printlocalAuthorityBeNotified,
        printlocalAuthorityBeenNotified,
        printparentsBeenInformed,
        printsecurityLevel,
        printaftercare,
        printchildAbsence,
        printsupervisionRateRespected,
        printusualTeam,
        ...rest
      } = data;
      rest.riskRelatedEvent =
        rest.riskRelatedEventArray?.map((value) => value).join("-,-") ?? "";
      rest.eventDate = moment(data.eventDate).format("YYYY-MM-DD");
      delete rest.riskRelatedEventArray;

      // Déterminer le statut correct en fonction du niveau de sécurité
      console.log("Security level during update:", rest.securityLevel);
      const securityLevel = Number(rest.securityLevel);
      const oldSecurityLevel = Number(data.securityLevel);
      
      // Toujours forcer la mise à jour du statut en fonction du niveau de sécurité actuel
      if (securityLevel >= 3) {
        console.log("Setting status to Need Validation for level:", securityLevel);
        rest.status = "Need Validation";
      } else {
        console.log("Setting status to Closed for level:", securityLevel);
        rest.status = "Closed";
      }
      
      console.log(`Updating status: old level ${oldSecurityLevel} -> new level ${securityLevel}, status set to ${rest.status}`);

      const response = await updateHealthEventsServie(rest, data._id);
      if (response.message === "updated") {
        // Créer un objet complet avec toutes les données nécessaires pour la mise à jour du tableau
        const updatedData = {
          ...response.data,
          _id: data._id,
          eventId: response.data.eventId || data.eventId, 
          // Assurez-vous que ces champs sont toujours inclus même s'ils ne sont pas dans response.data
          perimeter: response.data.perimeter || data.perimeter,
          institutionId: response.data.institutionId,
          event: "Health event",
          eventDate: rest.eventDate,
          // Ces valeurs sont cruciales pour la mise à jour de l'interface
          securityLevel: rest.securityLevel,
          status: rest.status
        };
        
        console.log("Mise à jour de l'enregistrement avec les données:", updatedData);
        // Appeler updateRecord avec les données complètes
        updateRecord(updatedData);
        toast.success("Your action has been successfully saved!");
        setLoading(false);
        setOpen(false);
      }
    } catch (error: any) {
      setLoading(false);
      toast.error(error);
    }
  };

  const resetForm = () => {
    setConfirmModalVisible(false);
    reset();
  };

  const updateReporting = async (value: string) => {
    setLoading(true);
    try {
      const response = await closeReporting(reportingId, { status: value });
      if (response.message === "updated") {
        updateRecord(response.data);
        toast.success("Your action has been successfully saved!");
        setLoading(false);
      }
    } catch (error: any) {
      setLoading(false);
      toast.error(error);
    }
  };

  const deleteEvent = (deleteConfirmed: boolean) => {
    if (deleteConfirmed) {
      setOpenDeletePopup(false);
      updateReporting(UPDATE_VALUES.DELETED);
    } else {
      setOpenDeletePopup(false);
    }
  };
  return (
    <section className="relative font-Poppins">
      <AdminWrapper>
        <DeletePopup
          deleteEvent={deleteEvent}
          open={openDeletePopup}
          setOpen={setOpenDeletePopup}
        />
      </AdminWrapper>
      <div>
        <div className="grid gap-3 lg:mx-10">
          <div className="w-16 h-16">
            <img
              src="/images/report.png"
              alt="!"
              className="max-w-full h-auto"
            />
          </div>
          <h1 className="text-4xl font-bold">
            <Trans t={t}>Health event</Trans>
          </h1>
          <p className="text-xl text-[#6B6B6B]">
            <Trans t={t}>
              Please report here health events relathed to the child
            </Trans>
          </p>
        </div>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="flex justify-end lg:px-[20px] my-10 gap-[15px]">
          <AdminWrapper>
            {editEnabled && (
              <button
                type="button"
                className="px-5 py-2 rounded-full text-white bg-[#1E408E]"
                onClick={() => setConfirmModalVisible(true)}
              >
                <Trans t={t}>Reset</Trans>
              </button>
            )}
            {!editEnabled && (
              <button
                type="button"
                className="px-5 py-2 rounded-full text-white bg-[#1E408E]"
                onClick={() => setEditEnabled(true)}
              >
                <Trans t={t}>Edit</Trans>
              </button>
            )}
            <button
              type="button"
              className="px-5 py-2 rounded-full text-white bg-[#1E408E]"
              onClick={() => setOpenDeletePopup(true)}
            >
              <Trans>Delete</Trans>
            </button>
            <button
              type="button"
              className="px-5 py-2 rounded-full text-white bg-[#1E408E]"
              onClick={() => updateReporting(UPDATE_VALUES.CLOSED)}
            >
              <Trans t={t}>Validate</Trans>
            </button>
          </AdminWrapper>
          {pdfData ? (
            <PDFDownloadLink
              className="px-5 py-2 rounded-full text-white bg-[#1E408E]"
              document={<HealthEventPDF formData={pdfData ?? {}} />}
              fileName={"health-event.pdf"}
            >
              {({ blob, url, loading, error }) =>
                loading ? "loading..." : "Download PDF"
              }
            </PDFDownloadLink>
          ) : (
            <button
              className="px-5 py-2 rounded-full text-white bg-[#1E408E]"
              onClick={handleSubmit(handleDownload)}
            >
              <Trans>Generate PDF</Trans>
            </button>
          )}
        </div>
        <div className="relative z-0 border border-gray-500 lg:mx-5">
          <div className="absolute -top-3 left-5 lg:-top-5 lg:left-14 bg-[white] px-[20px] lg:px-5">
            <h1 className="text-sm lg:text-3xl font-bold text-[#1E408E]">
              <Trans i18nKey="Event Details">Event Details</Trans>
            </h1>
          </div>
          <div className="md:p-16 sm:p-8 p-4 pt-16">
            <div className="grid gap-5">
              <FormDateInput
                type="Date"
                register={register}
                errors={errors}
                name="eventDate"
                printEnabled
                label="Event date"
                placeholder=""
                translateId="Event date"
                disabled={!editEnabled}
                date={date}
                setDate={setDate}
                control={control}
              />
              <Input
                type="Time"
                register={register}
                errors={errors}
                name="eventTime"
                label="Event time"
                printEnabled
                placeholder="hh:mm"
                translateId="Event time"
                disabled={!editEnabled}
              />
              <SelectElement
                register={register}
                errors={errors}
                name="eventMoment"
                printEnabled
                label="Event moment"
                options={[
                  "Play time",
                  "Sleep time",
                  "Changing/care time",
                  "Meal time",
                  "Reception time (morning and evening)",
                ]}
                translateId="Event moment"
                disabled={!editEnabled}
              />
              <SelectElement
                register={register}
                errors={errors}
                name="eventLocation"
                printEnabled
                label="Event location"
                options={[
                  "Interior (School indoor premise)",
                  "Exterior space (School outdoor premise)",
                  "Outside the establishment",
                ]}
                translateId="Event location"
                disabled={!editEnabled}
              />
              <SelectElement
                register={register}
                errors={errors}
                name="ageOfChild"
                printEnabled
                label="Age of the child involved in the incident"
                options={[
                  "Less than 1 year",
                  "1 to 2 years",
                  "2 to 3 years",
                  "3 to 4 years",
                  "4 to 5 years",
                  "5 to 6 years",
                  "More than 6 years old",
                ]}
                translateId="Aga of the child"
                disabled={!editEnabled}
              />
              <Checkboxes
                register={register}
                errors={errors}
                printEnabled
                name="eventType"
                options={[
                  { text: "Skin rash" },
                  { text: "Convulsion" },
                  { text: "Fever" },
                  { text: "Vomiting" },
                  { text: "Respiratory problem" },
                  { text: "Pain" },
                  { text: "Unwellness" },
                  { text: "Bleeding" },
                  { text: "Other health event" },
                ]}
                label="Event Type"
                translateId="Event Type"
                disabled={!editEnabled}
              />

              <TextArea
                register={register}
                errors={errors}
                printEnabled
                name="eventDescription"
                label="Event Description (factual & taken care of elements)"
                translateId="eventDescription"
                disabled={!editEnabled}
              />
              <SelectElement
                register={register}
                errors={errors}
                name="emsContacted"
                printEnabled
                label="EMS contacted"
                options={["Yes", "No"]}
                translateId="EMS contacted"
                disabled={!editEnabled}
              />
              <SelectElement
                register={register}
                errors={errors}
                printEnabled
                name="hospitalization"
                options={[
                  "No",
                  "Less than 24H",
                  "Less than 36H",
                  "Less than 48H",
                  "More than 48H",
                ]}
                label="Hospitalization (including emergency room)"
                translateId="hospitalization"
                disabled={!editEnabled}
              />
              <SelectElement
                register={register}
                errors={errors}
                name="aftercare"
                printEnabled
                label="Aftercare"
                options={[
                  "none",
                  "Yes, for few days",
                  "Yes, for few weeks",
                  "Yes, for few months",
                  "Yes, for more than a year",
                ]}
                translateId="Aftercare"
                disabled={!editEnabled}
              />
              <SelectElement
                register={register}
                errors={errors}
                name="childAbsence"
                printEnabled
                label="Child absence"
                options={[
                  // "No absence",
                  // "Returned the next day",
                  // "Absence of 1 to 3 days",
                  // "Absence for more than 3 days",
                  // "Parents have terminated the contract",
                  "No absence or maximum 1 day",
                  "Maximum 2 days",
                  "Maximum 3 days",
                  "Maximum 1 week",
                  "More than one week",
                  "Parents terminated the care agreement",
                ]}
                translateId="Child absence"
                disabled={!editEnabled}
              />
              <SelectAndQmark
                register={register}
                errors={errors}
                name="securityLevel"
                label="Severity level"
                printEnabled
                options={[0, 1, 2, 3, 4, 5]}
                translateId="Severity level"
                disabled={!editEnabled}
                i18nKey="Help Box - Health Event - Severity level"
                value={props.securityLevel}
              />
              <SelectElement
                register={register}
                errors={errors}
                printEnabled
                name="parentsBeenInformed"
                label="parentsBeenInformed"
                options={["Yes", "No"]}
                translateId="parentsBeenInformed"
                disabled={!editEnabled}
              />
              <SelectAndQmark
                register={register}
                printEnabled
                errors={errors}
                name="insuranceBeNotified"
                label="Will insurance claim be filed?"
                options={["Yes", "No"]}
                translateId="insuranceBeNotified"
                i18nKey="Help Box - Health Event - Does our Company Insurance need to be informed?"
              />

              <SelectElement
                register={register}
                errors={errors}
                name="insuranceBeenNotified"
                printEnabled
                label="Has the insurance claim been filed?"
                options={["Yes", "No"]}
                translateId="insuranceBeenNotified"
                // i18nKey="Help Box - Health Event - Does our Company Insurance need to be informed ?"
              />

              <SelectAndQmark
                register={register}
                printEnabled
                errors={errors}
                name="localAuthorityBeNotified"
                label="Should the local authority be notified?"
                options={["Yes", "No"]}
                translateId="localAuthorityBeNotified"
                disabled={!editEnabled}
                i18nKey="Help Box - Health Event - Does the local authority need to be informed?"
                value={props.localAuthorityBeNotified}
              />
              <SelectElement
                register={register}
                errors={errors}
                printEnabled
                name="localAuthorityBeenNotified"
                label="Has the local authority been notified?"
                options={["Yes", "No"]}
                translateId="localAuthorityBeenNotified"
                disabled={!editEnabled}
              />

              <SelectAndQmark
                register={register}
                errors={errors}
                name="supervisionRateRespected"
                printEnabled
                label="supervisionRateRespected"
                options={["Yes", "No"]}
                translateId="supervisionRateRespected"
                disabled={!editEnabled}
                i18nKey="Help Box - Health Event - When the event occurred, was the staff ratio in compliance with regulations?"
              />
              <SelectElement
                register={register}
                errors={errors}
                name="usualTeam"
                label="Usual team in the reception area ?"
                options={["Yes", "No"]}
                printEnabled
                translateId="usualTeam"
                disabled={!editEnabled}
              />
              <TextArea
                register={register}
                errors={errors}
                name="professionalNames"
                printEnabled
                label="Name of all professionals present in the unit where the event took place"
                translateId="professionalNames"
                disabled={!editEnabled}
              />
              <CustomCheckboxes
                register={register}
                errors={errors}
                name="riskRelatedEventArray"
                printEnabled
                label="Risks related to the Health incident"
                disabled={!editEnabled}
                options={[
                  {
                    text: "Risk of parents negatively influencing other parents in the school",
                  },
                  {
                    text: "Risk that parents will give bad publicity (social networks, negative comments on the internet)",
                  },
                  { text: "Legal risk (lawsuit)" },
                  { text: "Risk of partial closure of the school" },
                  { text: "Risk of temporary closure of the school" },
                  { text: "none" },
                ]}
                control={control}
              />
            </div>
          </div>
        </div>
        <AdminWrapper>
          <div className="flex justify-end lg:px-[20px] my-10">
            <button
              type={"submit"}
              className="px-5 py-2 rounded-full text-white bg-[#1E408E]"
            >
              <Trans i18nKey="Submit">Submit</Trans>
            </button>
            {loading && <Loaing />}
          </div>
        </AdminWrapper>
      </form>
      <ConfirmModal
        isOpen={confirmModalVisible}
        setIsOpen={setConfirmModalVisible}
        onConfirm={resetForm}
      />
    </section>
  );
};

export default UpdateHealthEvents;
